import { Avatar, Card, Stack, Typography } from '@mui/material'
import { EmphasizedNumber, ItemImageArea } from 'utoniq-ui'

import { MultipleItemsMissionFragment } from '@/clients/utoniq-core/schema'
import { styleSets } from '@/components/styles'
import { useTranslation } from '@/core'
import { Organism } from '@/core/architecture'

export type MultipleItemsMissionProps = {
  item: MultipleItemsMissionFragment
  sheet: number
  ownedCount: number
}

export const MultipleItemsMission: Organism<MultipleItemsMissionProps> = ({
  item,
  sheet,
  ownedCount,
}) => {
  const { t } = useTranslation('missionDetail')
  return (
    <Card elevation={0}>
      <Stack direction="row" sx={{ px: 5, py: 3 }} spacing={4}>
        <ItemImageArea
          src={item.thumbnail.front?.smallUri ?? ''}
          size="x-small"
        />
        <Stack
          flex={1}
          sx={{ pt: 2, minWidth: 0 }}
          justifyContent="space-between"
        >
          <Stack direction="row" alignItems="center" spacing={2}>
            <Stack flex={1} sx={{ minWidth: 0 }}>
              <Stack flex={1}>
                <Typography variant="subtitle1" sx={styleSets.lineCamp(1)}>
                  {item.title}
                </Typography>
              </Stack>
              <Stack direction="row" spacing={1}>
                {item.rarityIconImage?.smallUri && (
                  <Avatar
                    variant="square"
                    src={item.rarityIconImage.smallUri}
                    sx={{
                      height: 12,
                      width: 12,
                    }}
                  />
                )}
                {!!item.rarity?.name && (
                  <Typography variant="overline">
                    {t(item.rarity.name)}
                  </Typography>
                )}
              </Stack>
            </Stack>
            <Stack direction="row" spacing={1} alignItems="flex-end">
              <EmphasizedNumber variant="h1">{sheet}</EmphasizedNumber>
              <Typography variant="subtitle1">{t('sheet')}</Typography>
            </Stack>
          </Stack>
          <Stack direction="row" justifyContent="flex-end" spacing={1}>
            <Typography variant="overline" color="text.hint">
              {t('numberOfOwned')}
            </Typography>
            <Typography variant="overline" color="text.secondary">
              {ownedCount}/{item.issuedNumber ?? '∞'}
            </Typography>
          </Stack>
        </Stack>
      </Stack>
    </Card>
  )
}
